import { useAccountType, usePageTitle } from '@src/contexts';
import { UserInfo } from './UserInfo';
import { Breadcrumb } from '@src/components';
import { AccountTypeSelector } from '../components';
import { BellIcon, MoonIcon, SunIcon } from '@heroicons/react/24/solid';
import { useTheme } from '@src/theme';
import { Switch } from 'antd';

export function Navbar() {
    const { breadcrumbs } = usePageTitle();
    const { showAccountTypeSelector } = useAccountType();
    const { theme, toggleTheme } = useTheme();
    const isDark = theme.mode === 'dark';

    return (
        <div className="w-full flex items-center justify-between py-2">
            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 w-full">
                <div className="flex flex-col space-y-1 w-full sm:w-auto">
                    {breadcrumbs.length > 0 && (
                        <div
                            className="whitespace-nowrap text-B-24"
                            style={{ color: theme.semantic.textPrimary }}
                        >
                            {breadcrumbs[0].title}
                        </div>
                    )}

                    {breadcrumbs.length > 1 && <Breadcrumb />}
                </div>
                {showAccountTypeSelector && (
                    <div className="w-full sm:w-auto">
                        <AccountTypeSelector />
                    </div>
                )}
            </div>

            <div
                className="w-30 flex items-center p-2 rounded-xl space-x-2"
                style={{ backgroundColor: theme.semantic.surface }}
            >
                {/* <Switch
                    checkedChildren={<SunIcon width={20} color="orange" />}
                    unCheckedChildren={<MoonIcon width={20} />}
                    checked={isDark}
                    onClick={toggleTheme}
                /> */}

                <UserInfo />
            </div>
        </div>
    );
}
